import { render, staticRenderFns } from "./OutsourceDivisionTasks.vue?vue&type=template&id=37ef8e95&"
import script from "./OutsourceDivisionTasks.vue?vue&type=script&lang=js&"
export * from "./OutsourceDivisionTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports